/**
 * Trigger a browser download for a Blob using a transient anchor element.
 *
 * The object URL is revoked on a `setTimeout(..., 0)` so the click handler
 * can complete before the blob is freed.
 */
export function triggerDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 0);
}
